const FaqEndPoint = {
  getFaqList: {
    url: `/faq`,
    method: "GET",
  },
  getAllFaqList: {
    url: `/public/faq`,
    method: "GET",
  },
  addFaq: {
    url: `/faq`,
    method: "POST",
  },
  updateFaq: (id) => ({
    url: `/faq/${id}`,
    method: "PUT",
  }),
  deleteFaq: (id) => ({
    url: `/faq/${id}`,
    method: "DELETE",
  }),
};

export default FaqEndPoint;
